export default __webpack_public_path__ + "media/DeepBrainAI.4a167da1.svg";